export const credentialMonitoringInitialState = {
    data: {
        riskProfiles: [],
        selectedRiskProfile: [],
    },
    errors: [],
    filterBy : 'srchTxt|',
    sortBy : 'uId|asc,ttLgns|asc,cmpPwd|asc,wkPwd|asc',
    loading: false,
    selectedRiskProfileLoading: false,
    error: null,
    pageNo : 1,
    pageSize : 11,
    displaySize : 10,
    maxPageNo : -1,
    isLastPage: false,
    totalSize: 0,
}